import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./Category.css";

const Category = () => {
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true); // NEW

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/categories/get`);
        setCategories(response.data.categories || []);
      } catch (err) {
        setError("Failed to load categories. Please try again.");
      } finally {
        setIsLoading(false); // Loading complete (success or error)
      }
    };
    fetchCategories();
  }, []);

  return (
    <section className="category-section">
      <div className="category-wrapper">
        {/* ✅ Show error only if exists */}
        {error && (
          <div
            className="category-error"
            style={{
              background: "#fee2e2",
              color: "#dc2626",
              padding: "0.75rem",
              borderRadius: "0.5rem",
              marginBottom: "1rem",
              textAlign: "center",
              fontSize: "14px",
            }}
          >
            {error}
          </div>
        )}

        <div className="category-scroll">
          {/* ✅ Hide this until loading finishes */}
          {!isLoading && categories.length === 0 && !error && (
            <div className="category-empty" style={{ textAlign: "center", padding: "2rem", color: "#333" }}>
              No categories available.
            </div>
          )}

          {/* ✅ Show categories if available */}
          {categories.map((cat) => (
            <Link to={cat.link} className="category-link" key={cat.id || cat._id}>
              <div className="category-item">
                <img src={cat.image} alt={cat.name} className="category-img" />
                <div className="category-text">{cat.name}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Category;
